// src/constants.js
// All app-wide constants in one place.

// ── Pipeline definitions ─────────────────────────────────────────────────────
// Each pipeline has its own ordered stage list. STAGES = "Mattress" (default).
// ABM_STAGES = the Industrial pipeline; we only show Quote Sent + Closed Won
// per business decision (the other stages exist in HubSpot but aren't relevant
// for sales-rep daily kanban use).
export const STAGES = ["Quote Requested","Quote Sent","Follow Up Date","Closed Won","Closed Lost"];
export const ABM_STAGES = ["Quote Sent","Closed Won"];

// PIPELINES drives the tab toggle on the Pipeline tab.
// Each entry: { id, label, stages } where id is used for persistence/keys.
export const PIPELINES = [
  { id: "mattress", label: "Mattress Pipeline", stages: STAGES     },
  { id: "abm",      label: "ABM CNC/Quilter",   stages: ABM_STAGES },
];

export const STAGE_COLORS = {
  "Quote Requested":"#e8a838",
  "Quote Sent":"#444444",
  "Follow Up Date":"#666666",
  "Closed Won":"#1a8a4a",
  "Closed Lost":"#b01020",
};

// HubSpot internal stage IDs for the ABM (Industrial) pipeline.
// Used by hubspot.js to detect which pipeline a deal belongs to.
export const ABM_STAGE_IDS = {
  QUOTE_SENT: "981909633",
  CLOSED_WON: "981909637",
};

// ALL Closed Won stage IDs across every pipeline.
// Used by Quota dashboard "Sales Generated" to sum across both pipelines.
export const ALL_CLOSED_WON_STAGE_IDS = [
  "1056148837",  // Mattress pipeline Closed Won
  "981909637",   // ABM pipeline Closed Won
];

export const ADMIN_UN = "Admin";

export const QUOTA_METRICS = [
  {id:"calls",  label:"Calls Logged",    icon:"📞", isCurrency:false},
  {id:"visits", label:"In-Person Visits",icon:"🤝", isCurrency:false},
  {id:"emails", label:"Emails Sent",     icon:"✉",  isCurrency:false},
  {id:"quotes", label:"Quotes Created",  icon:"📋", isCurrency:false},
  {id:"sales",  label:"Sales Generated", icon:"💰", isCurrency:true},
];

export const DEFAULT_QUOTAS = {calls:80, visits:20, emails:150, quotes:30, sales:50000};

export const CAL_TYPES = {
  call:    {label:"Call",    icon:"📞", color:"#444444", bg:"#deeaf7"},
  visit:   {label:"Visit",   icon:"🤝", color:"#b01020", bg:"#fdecea"},
  email:   {label:"Email",   icon:"✉",  color:"#9b6ec8", bg:"#ecdff7"},
  quote:   {label:"Quote",   icon:"📋", color:"#e8a838", bg:"#fdf0d0"},
  meeting: {label:"Meeting", icon:"📅", color:"#111111", bg:"#e8e8e8"},
  note:    {label:"Note",    icon:"📝", color:"#555555", bg:"#f0ece8"},
  other:   {label:"Other",   icon:"📌", color:"#c0614a", bg:"#fdecea"},
};

export const MAIN_TABS = [
  {id:"companies", label:"Companies",  icon:"🏢"},
  {id:"contacts",  label:"Contacts",   icon:"👤"},
  {id:"pipeline",  label:"Pipeline",   icon:"💼"},
  {id:"route",     label:"Route Plan", icon:"🗺"},
  {id:"calendar",  label:"Calendar",   icon:"📅"},
  {id:"tasks",     label:"Tasks",      icon:"✅"},
  {id:"quota",     label:"Progress",   icon:"🎯"},
  {id:"salesai",   label:"Sales AI",   icon:"✨", adminOnly:true},
];

export const TAB_LABELS = {
  companies:"Companies",
  contacts:"Contacts",
  pipeline:"Pipeline",
  route:"Route Planner",
  calendar:"Calendar",
  tasks:"Tasks",
  quota:"My Progress",
  salesai:"Sales AI",
};
